/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type KeyType = 'ACTIVATION' | 'DEACTIVATION';

export const KeyType = {

    ACTIVATION: 'ACTIVATION' as KeyType,

    DEACTIVATION: 'DEACTIVATION' as KeyType
};

